import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Navigation, Pagination, Autoplay } from "swiper/modules"; 

const CityHome = ({ typ = "Hot" }) => {  
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

  useEffect(() => {
    fetch(`${API}/api/topareainabudhabi.ashx`) // 🔁 replace URL
      .then((res) => res.json())
      .then((res) => {
        console.log("API Response:", res);

        // ✅ Handle different API formats safely
        const result = Array.isArray(res) ? res : res.data;

        setCities(result || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setCities([]);
        setLoading(false);
      });
  }, []);

  // ✅ Loader
  if (loading) {
    return <div className="loader">Loading...</div>;
  }

  // ✅ Empty state
  if (!cities.length) {
    return <p>No data found</p>;
  }

  return (
    <div className="wrap-categories-sw wow fadeInUp" data-wow-delay=".2s">
      <Swiper
        spaceBetween={30}
        slidesPerView={6}
        modules={[Navigation, Pagination, Autoplay]} 
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 15 },
          640: { slidesPerView: 3, spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 30 },
          1024: { slidesPerView: 5, spaceBetween: 30 },
        }}
        className="tf-sw-categories"
      >
        {Array.isArray(cities) &&
          cities.map((city) => (
            <SwiperSlide key={city.id}>
              <div className="emirate-card">
                <Link to={`/properties-in-${city.slug}/${city.id}`}>
                  <img
                    src={city.ImagePath+'/w=340,sharpen=1'}
                    alt={city.Location}
                    loading="lazy"
                  />
                </Link>
                <Link to={`/properties-in-${city.slug}/${city.id}`}>
                  <h3>{city.Location}</h3>
                </Link>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default CityHome;